<template>
  <ClientListView
    :columns="columns"
    add-client-label="Add New Intermediary Client"
    add-client-route="/admin/clients/add"
    show-client-type-filter
  />
</template>

<script setup>
import ClientListView from '@/components/clients/ClientListView.vue';

const columns = [
  { key: 'clientName', label: 'Client Name', sortable: true },
  { key: 'milestone', label: 'Current Milestone', sortable: true },
  { key: 'customerType', label: 'Customer Type', sortable: true },
  { key: 'status', label: 'Project Status', sortable: true },
  { key: 'goLiveDate', label: 'Go Live Date', sortable: true },
];
</script>
